import React from 'react';
import { ButtonWrapper, TitleSkeleton, ButtonSkeleton } from './styles';
export function MainNavUserMenuSkeleton() {
  return /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(TitleSkeleton, null), /*#__PURE__*/React.createElement(ButtonSkeleton, {
    disabled: true
  }));
}
export default MainNavUserMenuSkeleton;